import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { useParams } from 'react-router-dom';
import { Query } from 'react-apollo';
import MembersEdit from './MembersEdit';
import { growlErrors } from '../../../utils/NotificationUtil';
import { Loading } from '../../../components/Loading';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';

const TEAM_REPORT_ASSESSMENTS = gql`
  query($accountId: ID!, $id: ID!) {
    account(id: $accountId) {
      id
      teamReport(id: $id) {
        id
        assessmentIds
      }
    }
  }
`;

const MembersEditContainer = ({ ...rest }) => {
  const { reportId } = useParams();
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const variables = {
    id: reportId,
    accountId: currentAccount,
  };
  return (
    <Query query={TEAM_REPORT_ASSESSMENTS} variables={variables}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
          return `Error ${error.message}`;
        }
        const {
          teamReport: { assessmentIds },
        } = data.account;

        return <MembersEdit {...rest} assessmentIds={assessmentIds} />;
      }}
    </Query>
  );
};

export default MembersEditContainer;
